import { useMutation } from '@tanstack/react-query';
import { updateOfficeProductivity } from '../clients/UpdateOfficeProductivity';
import { applyProductivity } from '../payloads/buildOfficePatch';
import type { IOfficeProductivityPayload } from '../types/LocationSettings';
import { useApplyLocationUpdate } from './useApplyLocationUpdate';

/** `PATCH /users/office-productivity` for one location, with its own `x-office`. */
export const useUpdateLocationProductivity = (officeId: string) => {
  const applyUpdate = useApplyLocationUpdate(officeId);

  return useMutation<unknown, unknown, IOfficeProductivityPayload>({
    mutationFn: (productivity) => updateOfficeProductivity(officeId, productivity),
    onSuccess: (_response, productivity) =>
      applyUpdate((office) => applyProductivity(office, productivity)),
    meta: { skipGlobalErrorToaster: true },
  });
};
